import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import PrintBonMedical from '@/components/caisse/factures/print-bons/print-bon-medical'

export default {
    name: 'bon-examen',
    components: {
        DateFilter, EnteteBonEtFacture, PrintBonMedical
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, 'patient', 'date',
                { key: 'action', label: 'Action.s' }
            ],

            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,

            filename: '',
            selected_bon: {
                date: "",
                reference: "",
                nom_patient: "",
                sexe: "",
                telephone: "",
                assurance: null,
                societe_souscripteur: null,
                examens: [
                    {
                        libelle: "",
                        prix_clinique: "",
                        montant_du: "",
                        montant_restant: null,
                        remise: null,
                        etat_annulation: null,
                        etat_paiement: "",
                        qte: "",
                        montant_paye: "",
                        part_assureur: null,
                        base_assurance: null,
                        taux_couverture: null,
                    },
                ]
            },
            total_du: 0,
            total_a_payer: 0,
            info_prestation: {
                total_prix_assure: 0,
                total_base_assurance: 0,
                total_part_assureur: 0,
                total_remise: 0,
                taux_couverture: ''
            },
            
            prestation: '',
            total_taxe_specifique: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.getListeBonExamen(data)
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        bons_examen_factures() {
            return this.$store.getters['bons_examen_factures'];
        },

        bons_length() {
            return this.bons_examen_factures.length;
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
    },

    methods: {
        getListeBonExamen(data) {
            this.is_load_error = false
            this.is_loading = true
            console.log(data);
            this.$store.dispatch("getBonExamenFacture", data).then(() => {
                if (this.bons_examen_factures.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeBonExamen(data)
        },

        viewDetail(bon) {
            const tmpstamp = this.current_date.getTime()
            this.filename = 'Bon d\'examen_'+bon.nom_patient+'_'+tmpstamp
            this.prestation = 'Bon d\'examen'

            this.selected_bon = bon

            this.info_prestation.total_remise  = 0
            this.info_prestation.total_base_assurance = 0
            this.info_prestation.total_prix_assure = 0
            this.info_prestation.total_part_assureur = 0
            this.total_a_payer = 0
            this.total_du  = 0
            bon.prestations.forEach(prestation => {
                this.total_du += prestation.montant_du
                this.total_a_payer += (prestation.prix_clinique > prestation.base_assurance)?prestation.prix_clinique:prestation.base_assurance

                this.info_prestation.taux_couverture = prestation.taux_couverture

                if (prestation.remise > 0) {
                    this.info_prestation.total_remise += prestation.remise
                }

                if (prestation.base_assurance > 0) {
                    this.info_prestation.total_base_assurance += prestation.base_assurance
                }

                if (prestation.prix_assure_clinique > 0) {
                    this.info_prestation.total_prix_assure += prestation.prix_assure_clinique
                }

                if (prestation.part_assureur > 0) {
                    this.info_prestation.total_part_assureur += prestation.part_assureur
                }
                this.total_taxe_specifique += prestation.taxe_specifique
            });


            setTimeout(() => {
                this.printPDF()
            }, 1000); 
        }
    }
}
